import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/auth/Login';
import VoucherList from './pages/accounts/VoucherList';
import VoucherCreate from './pages/accounts/VoucherCreate';
import VoucherDetail from './pages/accounts/VoucherDetail';
import JournalEntryDetail from './pages/accounts/JournalEntryDetail';
import ChartOfAccounts from './pages/accounts/ChartOfAccounts';
import CostCenters from './pages/accounts/CostCenters';
import Funds from './pages/accounts/Funds';
import FiscalPeriods from './pages/accounts/FiscalPeriods';
import VoucherTypes from './pages/accounts/VoucherTypes';
import TrialBalance from './pages/accounts/TrialBalance';
import Ledgers from './pages/accounts/Ledgers';
import FinancialPosition from './pages/accounts/FinancialPosition';
import RevenueExpenditure from './pages/accounts/RevenueExpenditure';
import CashBankPosition from './pages/accounts/CashBankPosition';
import Budgets from './pages/accounts/Budgets';
import Phases from './pages/accounts/Phases';
import Districts from './pages/accounts/Districts';
import Institutions from './pages/accounts/Institutions';
import ProgramReports from './pages/accounts/ProgramReports';
import Vehicles from './pages/accounts/Vehicles';
import BankReconciliation from './pages/accounts/BankReconciliation';
import Vendors from './pages/accounts/Vendors';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-blue-800 text-xl font-semibold">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/vouchers" element={<ProtectedRoute><VoucherList /></ProtectedRoute>} />
          <Route path="/vouchers/new" element={<ProtectedRoute><VoucherCreate /></ProtectedRoute>} />
          <Route path="/vouchers/:id" element={<ProtectedRoute><VoucherDetail /></ProtectedRoute>} />
          <Route path="/journal-entries/:id" element={<ProtectedRoute><JournalEntryDetail /></ProtectedRoute>} />
          <Route path="/chart-of-accounts" element={<ProtectedRoute><ChartOfAccounts /></ProtectedRoute>} />
          <Route path="/cost-centers" element={<ProtectedRoute><CostCenters /></ProtectedRoute>} />
          <Route path="/funds" element={<ProtectedRoute><Funds /></ProtectedRoute>} />
          <Route path="/fiscal-periods" element={<ProtectedRoute><FiscalPeriods /></ProtectedRoute>} />
          <Route path="/voucher-types" element={<ProtectedRoute><VoucherTypes /></ProtectedRoute>} />
          <Route path="/budgets" element={<ProtectedRoute><Budgets /></ProtectedRoute>} />
          <Route path="/phases" element={<ProtectedRoute><Phases /></ProtectedRoute>} />
          <Route path="/districts" element={<ProtectedRoute><Districts /></ProtectedRoute>} />
          <Route path="/institutions" element={<ProtectedRoute><Institutions /></ProtectedRoute>} />
          <Route path="/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
          <Route path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
          <Route path="/program-reports" element={<ProtectedRoute><ProgramReports /></ProtectedRoute>} />
          <Route path="/trial-balance" element={<ProtectedRoute><TrialBalance /></ProtectedRoute>} />
          <Route path="/ledgers" element={<ProtectedRoute><Ledgers /></ProtectedRoute>} />
          <Route path="/financial-statements/position" element={<ProtectedRoute><FinancialPosition /></ProtectedRoute>} />
          <Route path="/financial-statements/revenue-expenditure" element={<ProtectedRoute><RevenueExpenditure /></ProtectedRoute>} />
          <Route path="/financial-statements/cash-bank" element={<ProtectedRoute><CashBankPosition /></ProtectedRoute>} />
          <Route path="/bank-reconciliation" element={<ProtectedRoute><BankReconciliation /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/vouchers" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
